import {CommonEnv} from './environment.common';

export const environment = {
  ...CommonEnv,
  production: true,
  apiUrl: 'https://d3dpi9q94t3q19.cloudfront.net/',
  stripeKey: 'pk_live_51IJ5IYH3JoTHTTnOIL4ICF8AYMOelMjStfMLuFHNYcRibfIXvNR5V78KfoaKnOa41L1HxawnCYN7DEKdTA7pSxcy009FuCPPAM',
  API_ENDPOINT: 'https://d3dpi9q94t3q19.cloudfront.net'
};
